<template>
  <div class="detail">
    <van-overlay :show="value" @click="change(!value)" z-index="99">
      <div class="card" @click.stop>
        <div class="card-item">
          <!-- 一次性小烟 -->
          <div v-if="detail.productType === 1">
            <div class="flex justify-between">
              <div class="left">
                <div
                  class="connect flex align-center"
                  :style="{
                    color: idOfConnectedDevice === detail.id ? '#3EE192' : '#8F8F8F',
                  }"
                  @click.prevent.stop="changeConnectionStatus(detail)"
                >
                  <van-icon
                    style="margin-right: 8px"
                    size="24"
                    :name="
                      idOfConnectedDevice === detail.id
                        ? require('@/assets/images/icon/on.png')
                        : require('@/assets/images/icon/off.png')
                    "
                  />
                  {{ idOfConnectedDevice === detail.id ? "connect" : "disconnect" }}
                </div>
                <div class="title">{{ detail.nameEn }}</div>
                <div class="desc">
                  Flavor:
                  <span style="margin-left: 2px">{{
                    detail.tasteNameEn | expandText(expand, 20)
                  }}</span>
                </div>
                <div class="desc">
                  Strength:
                  <span style="margin-left: 2px"
                    >{{ detail.nicotineInhalation }}mg/ml</span
                  >
                </div>
                <div class="step-container flex align-center">
                  <van-icon
                    style="margin-right: 4px"
                    size="14"
                    :name="require('@/assets/images/icon/oil.png')"
                  />
                  <div class="step-bg">
                    <span
                      :style="{ width: `${detail.surplusTimes * 100}%` }"
                    ></span>
                  </div>
                </div>
                <div class="desc">
                  Puff count:
                  <span style="color: #3be199; margin-left: 2px">{{
                    detail.cusumInhalationTimes
                  }}</span>
                </div>
              </div>
              <div class="right flex justify-between">
                <div class="flex align-center">
                  <img :src="detail.picture" />
                </div>
                <van-icon
                  size="22"
                  name="like"
                  :color="detail.isLike ? '#FF6363' : '#CECECE'"
                  @click="editLike_DetailsDialog"
                />
              </div>
            </div>
            <div
              class="flex justify-center"
              style="margin: 0 auto -10px"
              @click="expand = !expand"
            >
              <van-icon
                style="margin-right: 14px"
                size="10"
                :name="require('@/assets/images/icon/expand.png')"
              />
            </div>
          </div>
          <!-- 换弹式小烟 -->
          <div v-else>
            <div class="flex justify-between">
              <div class="left">
                <div class="desc">
                  Flavor:
                  <span v-if="forElementControl.eJuiceIsConnected" style="margin-left: 2px">{{
                    (cartridgesDetail.tasteNameEn ? cartridgesDetail.tasteNameEn : '') | expandText(expand, 20)
                  }}</span>
                </div>
                <div class="desc">
                  Strength:
                  <span v-if="forElementControl.eJuiceIsConnected" style="margin-left: 2px"
                    >{{ cartridgesDetail.nicotineInhalation }}mg/ml</span
                  >
                </div>
                <div class="step-container flex align-center">
                  <van-icon
                    style="margin-right: 4px"
                    size="14"
                    :name="require('@/assets/images/icon/oil.png')"
                  />
                  <div v-if="forElementControl.eJuiceIsConnected" class="step-bg">
                    <span
                      :style="{
                        width: `${oilMeter * 100}%`,
                      }"
                    ></span>
                  </div>
                </div>
                <div class="desc">
                  Puff count:
                  <span
                    v-if="forElementControl.eJuiceIsConnected"
                    style="color: #3be199; margin-left: 2px"
                    >{{ cartridgesDetail.cusumInhalationTimes }}</span
                  >
                </div>
              </div>
              <div class="right flex justify-between">
                <div class="flex align-center"></div>
                <van-icon
                  size="22"
                  name="like"
                  :color="
                    forElementControl.eJuiceIsConnected && cartridgesDetail.isLike
                      ? '#FF6363'
                      : '#CECECE'
                  "
                  @click="editLike_Cartridges"
                />
              </div>
            </div>
            <div
              class="flex justify-center"
              style="margin: 0 auto -10px"
              @click="expand = !expand"
            >
              <van-icon
                style="margin-right: 14px"
                size="10"
                :name="require('@/assets/images/icon/expand.png')"
              />
            </div>
            <div class="item-container" style="padding: 20px 0 0">
              <div class="flex justify-between">
                <div class="left">
                  <div
                    class="connect flex align-center"
                    :style="{
                      color: idOfConnectedDevice === detail.id ? '#3EE192' : '#8F8F8F',
                    }"
                    @click.prevent.stop="changeConnectionStatus(detail)"
                  >
                    <van-icon
                      style="margin-right: 8px"
                      size="24"
                      :name="
                        idOfConnectedDevice === detail.id
                          ? require('@/assets/images/icon/on.png')
                          : require('@/assets/images/icon/off.png')
                      "
                    />
                    {{ idOfConnectedDevice === detail.id ? "connect" : "disconnect" }}
                  </div>
                  <div class="title">{{ detail.nameEn }}</div>
                  <div v-if="idOfConnectedDevice === detail.id" class="flex align-center">
                    <van-icon v-if="battery === -1" size="22" :name="require('@/assets/images/icon/power_empty.png')" />
                    <van-icon v-if="battery === 0" size="22" :name="require('@/assets/images/icon/batteryActivity_Low.png')" />
                    <van-icon v-if="battery === 1" size="22" :name="require('@/assets/images/icon/batteryActivity_Medium.png')" />
                    <van-icon v-if="battery === 2" size="22" :name="require('@/assets/images/icon/batteryActivity_High.png')" />
                  </div>
                  <div v-if="idOfConnectedDevice !== detail.id" class="flex align-center">
                    <van-icon size="22" :name="require('@/assets/images/icon/power_empty.png')" />
                  </div>
                </div>
                <div class="right flex justify-between">
                  <div class="flex align-center">
                    <img :src="productImage" />
                  </div>
                  <van-icon
                    size="22"
                    name="like"
                    :color="detail.isLike ? '#FF6363' : '#CECECE'"
                    @click="editLike_DetailsDialog"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="item-container">
            <van-tabs
              v-model="detail.gears"
              type="card"
              background="#fff"
              title-inactive-color="#eee"
              :before-change="beforeChangePower"
              @change="changePower"
            >
              <van-tab title="Soft" :name="1"></van-tab>
              <van-tab title="Norm" :name="2"></van-tab>
              <van-tab title="All in" :name="3"></van-tab>
            </van-tabs>
          </div>
          <div class="item-container flex justify-around">
            <div
              class="text-icon flex-column align-center"
              @click="changeLockState"
            >
              <van-icon
                size="22"
                :name="
                  detail.isOpenLock
                    ? require('@/assets/images/icon/lock.png')
                    : require('@/assets/images/icon/unlock.png')
                "
              ></van-icon>
              {{ detail.isOpenLock ? "Auto lock" : "Auto lock" }}
            </div>
            <div class="center-btn border-radius-4" @click="zen">ZEN</div>
            <div class="text-icon flex-column align-center" @click="setting">
              <van-icon
                size="22"
                :name="require('@/assets/images/icon/setting.png')"
              ></van-icon>
              Setting
            </div>
          </div>
          <!-- <div class="item-container">
            <div class="week flex justify-around" v-if="value">
              <div
                class="week-item flex-column justify-end align-center"
                v-for="(item, index) in detail.smokingVos"
                :key="index"
              >
                <div
                  class="
                    progress-container
                    flex-column-reverse
                    justify-start
                    align-center
                  "
                >
                  <div
                    :class="
                      item.inhalationTimes === max && max > 0
                        ? 'progress fill'
                        : 'progress'
                    "
                    :style="`height: ${(item.inhalationTimes / max) * 100}%`"
                  ></div>
                  <span class="num">{{ item.inhalationTimes }}</span>
                </div>
                <span class="date">{{ item.belongsToDate }}</span>
              </div>
            </div>
            <div class="total">
              Total <span>{{ detail.cusumInhalationTimes }}</span> puffs
            </div>
          </div> -->
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { editGears, getCartridgesDetail, editCartridgesLike } from "@/api";
export default {
  props: {
    changeConnectionStatus: {
      type: Function,
      default: () => {},
    },
    detail_Props: {
      type: Object,
      default: () => {
        return {};
      },
    },
    editLike: {
      type: Function,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  watch: {
    value: function(val, oldVal) {
      if (val) {
        this.detail = this.detail_Props;
        
        // 当详情页窗体显示时
        window.changePower_Succeed = this.changePower_Succeed_Callback; // 注册 修改功率成功后 的回调函数
        window.changePower_Failed = this.changePower_Failed_Callback; // 注册 修改功率失败后 的回调函数
        window.changeLockState_Succeed = this.changeLockState_Succeed_Callback; // 注册 修改锁状态成功后 的回调函数
        window.changeLockState_Failed = this.changeLockState_Failed_Callback; // 注册 修改锁状态失败后 的回调函数
        window.resultOfZen_Succeed = this.resultOfZen_Succeed_Callback; // 注册 Zen成功后 的回调函数
        window.resultOfZen_Failed = this.resultOfZen_Failed_Callback; // 注册 Zen失败后 的回调函数
        window.pushCusumInhalationTimesOfDevice = this.whenCusumInhalationTimesOfDeviceReceived; // 注册 吸烟口数变化后 的回调函数

        switch (this.detail.productType) {
          case 1: // 烟油内嵌在设备中,不支持更换烟油
            this.$toast.clear();
            break;

          case 2: // 支持更换烟油的烟杆
            if (this.idOfConnectedDevice === this.detail.id) {
              this.battery = this.theLatestBattery;
              if (this.theLatesEJuiceId !== '0') {
                this.productImage = this.detail.picture;
              } else {
                this.productImage = this.detail.pictureSecond;
              }
            } else {
              this.battery = -1;
              this.productImage = this.detail.pictureSecond;
            }
            this.updateCartridgesDetail();
            break;
        }
      } else {
        if (this.idOfConnectedDevice === this.detail.id) {
          /** 通知宿主将退出设备详情页 */
          window.webkit.messageHandlers.whenDeviceDetailsPageDestroyed.postMessage(
            this.detail.equipmentName
          );
        }
      }
    },
    idOfConnectedDevice: function(val, oldVal) {
      if (val === this.detail.id) {
        // 当前连接的设备 是 详情页的设备
        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            this.forElementControl.eJuiceIsConnected = true;
            this.productImage = this.detail.picture;
            this.battery = this.theLatestBattery;
            this.updateCartridgesDetail();
            break;
        }
      } else {
        // 当前连接的设备 不是 详情页的设备

        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            this.forElementControl.eJuiceIsConnected = false;
            this.productImage = this.detail.pictureSecond;
            this.battery = -1;
            this.cartridgesDetail = {};
            break;
        }
      }
    },
    theLatestBattery: function(val, oldVal) {
      if (this.idOfConnectedDevice === this.detail.id) {
        // 当前连接的设备 是 详情页的设备

        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            this.battery = val;
            break;
        }
      } else {
        // 当前连接的设备 不是 详情页的设备

        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            this.battery = -1
            break;
        }
      }
    },
    theLatesEJuiceId: function(val, oldVal) {
      if (this.idOfConnectedDevice === this.detail.id) {
        // 当前连接的设备 是 详情页的设备

        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            if (val !== '0') {
              this.forElementControl.eJuiceIsConnected = true;
              this.productImage = this.detail.picture;
              this.updateCartridgesDetail(val);
            } else {
              this.forElementControl.eJuiceIsConnected = false;
              this.productImage = this.detail.pictureSecond;
              this.cartridgesDetail = {};
            }
            break;
        }
      } else {
        // 当前连接的设备 不是 详情页的设备

        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            this.forElementControl.eJuiceIsConnected = false;
            this.productImage = this.detail.pictureSecond;
            this.cartridgesDetail = {};
            break;
        }
      }
    },
    theCusumInhalationTime: function(val, oldVal) {
      this.updateOilMeter();
    },
  },
  data() {
    return {
      expand: false,

      detail: {}, // 详情信息

      /** 页面元素控制 */
      forElementControl: {
        eJuiceIsConnected: false
      },

      cartridgesDetail: {}, // 烟弹详情
      productImage: '',
      battery: -1, // 连接着的设备的电量
      oilMeter: 0, // 连接着的设备的烟油剩余(0 ～ 1)
    };
  },
  computed: {
    idOfConnectedDevice() {
      return this.$store.state.app.idOfConnectedDevice;
    },
    theLatestBattery() {
      return this.$store.state.app.theLatestBattery;
    },
    theLatesEJuiceId() {
      return this.$store.state.app.theLatesEJuiceId;
    },
    theCusumInhalationTime() {
      return this.$store.state.app.theCusumInhalationTime;
    },
    max() {
      return Math.max.apply(
        Math,
        this.detail.smokingVos.map((item) => {
          return item.inhalationTimes;
        })
      );
    },
  },
  filters: {
    // 文字拓展 text: 需要隐藏的内容 expand：是否需要省略 length：大于多少字节就会隐藏
    expandText(text, expand, length) {
      if (expand) {
        return text;
      } else {
        if (text.length < length) {
          return text;
        } else {
          return text.substring(0, length) + "...";
        }
      }
    },
  },
  methods: {
    /** 更新电量 */
    updateBattery() {
      if (this.idOfConnectedDevice === this.detail.id) {
        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            this.battery = this.$store.state.app.theLatestBattery;
            break;
        }
      } else {
        this.battery = -1;
      }
    },
    /** 更新烟弹详情 */
    updateCartridgesDetail(newTheLatesEJuiceId) {
      if (this.idOfConnectedDevice === this.detail.id) {
        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            if (
              newTheLatesEJuiceId
              || this.theLatesEJuiceId !== '0'
            ) {
              getCartridgesDetail({
                cartridgesCode: newTheLatesEJuiceId ? newTheLatesEJuiceId : this.theLatesEJuiceId,
              }).then((res) => {
                if (res.code === 200) {
                  this.cartridgesDetail = res.data;
                  this.updateOilMeter();
                  this.forElementControl.eJuiceIsConnected = true;
                }
                this.$toast.clear();
              });
            } else {
              this.$toast.clear();
            }
            break;
        }
      } else {
        this.$toast.clear();
      }
    },
    /** 更新烟油剩余指示条 */
    updateOilMeter() {
      if (this.idOfConnectedDevice === this.detail.id) {
        switch (this.detail.productType) {
          case 2: // 支持更换烟油的烟杆
            this.oilMeter = 1 - ((this.theCusumInhalationTime / 10) / this.cartridgesDetail.inhalationTime).toFixed(2);
            break;
        }
      }
    },
    // /** 当前设备已连接 */
    curDeviceIsConnected(doNotShowToast) {
      const result = this.$store.state.app.idOfConnectedDevice === this.detail.id;
      if (!result && !doNotShowToast) this.$toast("Please connect device.");
      return result;
    },
    /** 当前烟弹已连接 */
    eJuiceIsConnected(doNotShowToast) {
      if (this.curDeviceIsConnected(doNotShowToast)) {
        const result = this.$store.state.app.theLatesEJuiceId !== "0";
        if (!result && !doNotShowToast) this.$toast("Please load the E-Juice.");
        return result;
      } else {
        return false;
      }
    },
    /** 需要拒绝操作 */
    need2Reject(doNotShowToast) {
      let result;
      switch (this.detail.productType) {
        case 1: // 烟油内嵌在设备中,不支持更换烟油
          result = !this.curDeviceIsConnected(doNotShowToast);
          break;

        case 2: // 支持更换烟油的烟杆
          result = !this.eJuiceIsConnected(doNotShowToast);
          break;

        case 3: // 烟油
          result = true;
          break;

        default:
          result = true;
      }
      return result;
    },
    /** 关闭设备详情窗体会调这个函数 */
    change(val) {
      this.$emit("input", val);
    },
    /** 更改设备收藏状态 */
    editLike_DetailsDialog() {
      const to = this.detail.isLike === 0 ? 1 : 0;
      this.editLike(
        this.detail,
        () => {
          this.detail.isLike = to;
        }
      );
    },
    /** 修改烟弹的"喜欢"状态 */
    editLike_Cartridges() {
      if (this.need2Reject(false)) return;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      const to = this.cartridgesDetail.isLike === 0 ? 1 : 0;
      editCartridgesLike({
        cartridgesCode: this.theLatesEJuiceId,
        isLike: to,
      }).then((res) => {
        this.$toast.clear();
        if (res.code !== 200) return;
        this.cartridgesDetail.isLike = to;
      });
    },
    /** 修改功率前 */
    beforeChangePower(index) {
      return this.curDeviceIsConnected(false);
    },
    /** 页面点击事件·修改功率 */
    changePower(newIndex) {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      var param = null;
      switch ("" + newIndex) {
        case "1":
          param = this.detail.minmumPower;
          break;

        case "2":
          param = this.detail.defaultPower;
          break;

        case "3":
          param = this.detail.maximumPower;
          break;

        default:
      }
      window.webkit.messageHandlers.whenPowerChanged.postMessage(param); // 通知宿主更改功率
    },
    /** 修改功率成功回调(宿主是调用方) */
    changePower_Succeed_Callback(x) {
      editGears({
        id: this.detail.id,
        gears: this.detail.gears,
      }).then((res) => {
        this.$toast.clear();
        this.$toast("operate successful")
      });
    },
    /** 修改功率失败回调(宿主是调用方) */
    changePower_Failed_Callback(x) {
      this.$toast.clear();
      this.$toast("Failed to modify power.");
    },
    /** 更改锁状态 */
    changeLockState() {
      if (!this.curDeviceIsConnected(false)) return;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      var param = null;
      switch ("" + this.detail.isOpenLock) {
        case "0":
          param = "true";
          break;
        case "1":
          param = "false";
          break;
        default:
      }
      window.webkit.messageHandlers.try2ChangeLockState.postMessage(param);
    },
    /** 修改锁状态成功回调(宿主是调用方) */
    changeLockState_Succeed_Callback(res) {
      this.detail.isOpenLock = this.detail.isOpenLock === 1 ? 0 : 1;
      this.$toast.clear();
      this.$toast("operate successful");
    },
    /** 修改锁状态失败回调(宿主是调用方) */
    changeLockState_Failed_Callback(res) {
      this.$toast.clear();
      this.$toast("operate fail");
    },
    zen() {
      if (!this.curDeviceIsConnected(false)) return;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      window.webkit.messageHandlers.whenZenButtonBeenClick.postMessage(
        "Meaningless"
      );
    },
    /** Zen成功回调(宿主是调用方) */
    resultOfZen_Succeed_Callback(res) {
      this.$toast.clear();
      this.$toast("operate successful");
    },
    /** Zen失败回调(宿主是调用方) */
    resultOfZen_Failed_Callback(res) {
      this.$toast.clear();
      this.$toast("operate fail");
    },
    /** 跳转设置界面 */
    setting() {
      if (!this.curDeviceIsConnected(false)) return;
      this.$router.push(
        {
          name: 'setup',
          params: {
            deviceInfo: this.detail
          }
        }
      );
    },
    /** 当收到设备的累计吸入次数时 */
    whenCusumInhalationTimesOfDeviceReceived(res) {
      if (this.need2Reject(true)) return;
      var fromDevice = parseInt(res);
      if (isNaN(fromDevice)) fromDevice = 0;
      let fromWebServer;
      switch(this.detail.productType) {
        case 1: // 烟油内嵌在设备中,不支持更换烟油
          fromWebServer = parseInt(this.detail.cusumInhalationTimes);
          if (isNaN(fromWebServer)) fromWebServer = 0;
          this.detail.cusumInhalationTimes = fromDevice > fromWebServer ? fromDevice : fromWebServer + 1;
          break;
        case 2: // 支持更换烟油的烟杆
          fromWebServer = parseInt(this.cartridgesDetail.cusumInhalationTimes);
          if (isNaN(fromWebServer)) fromWebServer = 0;
          this.cartridgesDetail.cusumInhalationTimes = fromDevice > fromWebServer ? fromDevice : fromWebServer + 1;
          break;
      }
    },
  },
};
</script>

<style lang="less">
.detail {
  .card {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 100px);
  }
  .item-container {
    margin-top: 30px;
    padding: 40px 20px;
    border-top: 1px solid #eee;
  }
  .van-tabs--card > .van-tabs__wrap {
    height: 64px;
  }
  .van-tabs__nav--card {
    border-color: #eee;
    border-radius: 15px;
    height: 64px;
    .van-tab {
      border-right: none;
    }
    .van-tab.van-tab--active {
      border-radius: 15px;
      background: linear-gradient(30deg, #3ee191, #24dedd);
    }
  }
  .text-icon {
    font-size: 20px;
    line-height: 2.5;
    color: #7f7f7f;
  }
  .center-btn {
    position: relative;
    background: linear-gradient(30deg, #3ee191, #24dedd);
    border-radius: 50%;
    z-index: 1;
    width: 93px;
    height: 93px;
    text-align: center;
    line-height: 93px;
    color: #fff;
    box-sizing: border-box;
    font-size: 21px;
    &:after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
      width: 98px;
      height: 98px;
      border-radius: 50%;
      background: linear-gradient(30deg, #3ee191, #24dedd);
      /* 径向渐变中的 最大圆计算方法为 (外圆宽度 - 内圆宽度 / 2)，此处为 113px - 92px / 2 */
      // mask-image: radial-gradient(transparent 0 60px, #000 60px);
      // -webkit-mask-image: radial-gradient(transparent 0 60px, #000 60px);
    }
  }
  .week {
    .week-item {
      .num {
        font-size: 18px;
        margin-bottom: 8px;
      }
      .progress-container {
        height: 180px;
        width: 50px;
        .progress {
          width: 100%;
          background: #e5e5e5;
          border-radius: 10px;
          border-bottom: 1px solid #e5e5e5;
        }
        .fill {
          background: linear-gradient(30deg, #3ee191, #24dedd);
        }
        .fill + span {
          color: #3be199;
        }
      }
      .date {
        margin-top: 8px;
        font-size: 15px;
      }
    }
  }
  .total {
    font-size: 32px;
    text-align: center;
    margin-top: 20px;
    font-weight: bold;
    font-style: italic;
    span {
      margin: 0 5px;
      font-style: normal;
      font-size: 38px;
      background-image: -webkit-gradient(
        linear,
        left 0,
        right 0,
        from(#3ee191),
        to(#24dedd)
      );
      -webkit-background-clip: text; /*必需加前缀 -webkit- 才支持这个text值 */
      -webkit-text-fill-color: transparent; /*text-fill-color会覆盖color所定义的字体颜色： */
      // color: linear-gradient(30deg, #3EE191, #24DEDD);
    }
  }
}
</style>
